import { Button } from "@mui/material";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { createPost } from "../../../feature/posts/postSlice";
import "./createBlog.scss";
import EditorToolbar, { formats, modules } from "./EditorToolbar";

const CreateBlog = () => {
  const [title, setTitle] = useState("");
  const [image, setImage] = useState("");
  const [imgUrl, setImgUrl] = useState(null);
  const [body, setBody] = useState({ value: null });

  const dispatch = useDispatch();

  const handleImgUpload = () => {
    const myData = new FormData();
    myData.append("file", image);
    myData.append("upload_preset", "portfolio");
    myData.append("cloud_name", "djwncpbir");

    fetch("https://api.cloudinary.com/v1_1/djwncpbir/image/upload", {
      method: "post",
      body: myData,
    })
      .then((res) => res.json())
      .then((data) => setImgUrl(data.url))
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSumbit = (e) => {
    e.preventDefault();

    const post = { title, image: imgUrl, body, views: 0 };
    dispatch(createPost(post));
    setTitle("");
    setImage("");
    setBody({ value: null });
    toast.success("Post Created successfully", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "dark",
      pauseOnHover: true,
      draggable: true,
      Limit: 1,
    });
  };

  return (
    <div className="create-blog-container">
      <h2>Create Blog Post: </h2>
      <div className="inp-blog">
        <form onSubmit={handleSumbit}>
          <input
            className="title common-input"
            type="text"
            name="title"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            placeholder="Title Of Blog Post"
          />
          <br />
          <div className="file-inp">
            <input
              type="file"
              name="image"
              onChange={(e) => setImage(e.target.files[0])}
            />
            <Button className="img-btn" onClick={handleImgUpload}>
              Upload
            </Button>
          </div>
          <div className="text-editor">
            <EditorToolbar />
            <ReactQuill
              className="text-aria"
              theme="snow"
              value={body.value}
              onChange={(value) => setBody({ value })}
              placeholder={"Write Your Blog..."}
              modules={modules}
              formats={formats}
            />
          </div>
          <Button className="submit-btn" type="submit">
            Submit
          </Button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default CreateBlog;
